// Translation: Interface > Pagination (Russian)
export default Object.freeze({
	options: {
		first: {
			label: ''
		},
		last: {
			label: ''
		},
		next: {
			label: ''
		},
		previous: {
			label: ''
		}
	}
})
